import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import UpdateUserRequest from '../../../users/base/i-service/models/requests/UpdateUserRequest';
import RemoveUserRequest from '../../../users/base/i-service/models/requests/RemoveUserRequest';
import LoginRequest from '../../../users/base/i-service/models/requests/LoginRequest';
import RegisterUserRequest from '../../../users/base/i-service/models/requests/RegisterUserRequest';
import ResetPasswordGetTokenRequest from '../../../users/base/i-service/models/requests/ResetPasswordGetTokenRequest';
import ResetPasswordRequest from '../../../users/base/i-service/models/responses/ResetPasswordRequest';
import GetUserShortInfoByTokenActivationRequest from '../../../users/base/i-service/models/requests/GetUserShortInfoByTokenActivationRequest';
import GetUserRequest from '../../../users/base/i-service/models/requests/GetUserRequest';
import ActivateUserRequest from '../../../users/base/i-service/models/requests/ActivateUserRequest';
import FastActivateUserRequest from '../../../users/base/i-service/models/requests/FastActivateUserRequest';
import ChangePasswordUserRequest from '../../../users/base/i-service/models/requests/ChangePasswordUserRequest';
import ChangePasswordForUserRequest from '../../../users/profile/i-service/models/request/ChangePasswordForUserRequest';
import TypeRoles from '../../../users/implementation/TypeRoles';
import GetUsersRequest from '../../../users/base/i-service/models/requests/GetUsersRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import BaseResponseT from '../../../tirscript/common/response-models/BaseResponseT';
import ListResponseT from '../../../tirscript/common/response-models/ListResponseT';
import RoleResponse from '../../../users/base/i-service/models/responses/RoleResponse';
import BaseResponse from '../../../tirscript/common/response-models/BaseResponse';
import UserResponse from '../../../users/base/i-service/models/UserResponse';
import RegisterUserResponse from '../../../users/base/i-service/models/responses/RegisterUserResponse';
import ResetPasswordGetTokenResponse from '../../../users/base/i-service/models/responses/ResetPasswordGetTokenResponse';
import GetUserShortInfoByTokenActivationResponse from '../../../users/base/i-service/models/responses/GetUserShortInfoByTokenActivationResponse';
import UserModel from '../../../users/base/i-service/models/responses/UserModel';
import SearchUserResponse from '../../../users/base/i-service/models/responses/SearchUserResponse';
import GetAdminUsersResponse from '../../../users/base/i-service/models/responses/GetAdminUsersResponse';

export default class UsersService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetRolesEvent = new Events<WsResponseModelT<BaseResponseT<ListResponseT<RoleResponse>>>>();
	UpdateUserEvent = new Events<WsResponseModelT<BaseResponse>>();
	DeleteUserEvent = new Events<WsResponseModelT<BaseResponse>>();
	LoginEvent = new Events<WsResponseModelT<UserResponse>>();
	RegisterUserEvent = new Events<WsResponseModelT<BaseResponseT<RegisterUserResponse>>>();
	ResetPasswordGetTokenEvent = new Events<WsResponseModelT<BaseResponseT<ResetPasswordGetTokenResponse>>>();
	ResetPasswordEvent = new Events<WsResponseModelT<BaseResponseT<UserResponse>>>();
	GetUserShortInfoByTokenActivationEvent = new Events<WsResponseModelT<GetUserShortInfoByTokenActivationResponse>>();
	LogoutEvent = new Events<WsResponseModelT<BaseResponse>>();
	GetCurrentUserEvent = new Events<WsResponseModelT<UserResponse>>();
	GetUserEvent = new Events<WsResponseModelT<UserModel>>();
	RegisterEvent = new Events<WsResponseModelT<RegisterUserResponse>>();
	ActivateEvent = new Events<WsResponseModelT<UserResponse>>();
	FastActivateUserEvent = new Events<WsResponseModelT<UserResponse>>();
	RemoveUserEvent = new Events<WsResponseModelT<BaseResponse>>();
	ChangePasswordEvent = new Events<WsResponseModelT<BaseResponse>>();
	ChangePasswordForUserEvent = new Events<WsResponseModelT<BaseResponse>>();
	UsersInRolesEvent = new Events<WsResponseModelT<Array<number>>>();
	GetListEvent = new Events<WsResponseModelT<SearchUserResponse>>();
	GetShortUserEvent = new Events<WsResponseModelT<SearchUserResponse>>();
	GetAdminUsersEvent = new Events<WsResponseModelT<Array<GetAdminUsersResponse>>>();
	GetRolesListEvent = new Events<WsResponseModelT<ListResponseT<RoleResponse>>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('UsersService', 'GetRoles', 'Main', (res: WsResponseModelT<BaseResponseT<ListResponseT<RoleResponse>>>) => {
			self.GetRolesEvent.trigger(res);
		});
		webApiService.on('UsersService', 'UpdateUser', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.UpdateUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'DeleteUser', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.DeleteUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'Login', 'Main', (res: WsResponseModelT<UserResponse>) => {
			self.LoginEvent.trigger(res);
		});
		webApiService.on('UsersService', 'RegisterUser', 'Main', (res: WsResponseModelT<BaseResponseT<RegisterUserResponse>>) => {
			self.RegisterUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'ResetPasswordGetToken', 'Main', (res: WsResponseModelT<BaseResponseT<ResetPasswordGetTokenResponse>>) => {
			self.ResetPasswordGetTokenEvent.trigger(res);
		});
		webApiService.on('UsersService', 'ResetPassword', 'Main', (res: WsResponseModelT<BaseResponseT<UserResponse>>) => {
			self.ResetPasswordEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetUserShortInfoByTokenActivation', 'Main', (res: WsResponseModelT<GetUserShortInfoByTokenActivationResponse>) => {
			self.GetUserShortInfoByTokenActivationEvent.trigger(res);
		});
		webApiService.on('UsersService', 'Logout', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.LogoutEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetCurrentUser', 'Main', (res: WsResponseModelT<UserResponse>) => {
			self.GetCurrentUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetUser', 'Main', (res: WsResponseModelT<UserModel>) => {
			self.GetUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'Register', 'Main', (res: WsResponseModelT<RegisterUserResponse>) => {
			self.RegisterEvent.trigger(res);
		});
		webApiService.on('UsersService', 'Activate', 'Main', (res: WsResponseModelT<UserResponse>) => {
			self.ActivateEvent.trigger(res);
		});
		webApiService.on('UsersService', 'FastActivateUser', 'Main', (res: WsResponseModelT<UserResponse>) => {
			self.FastActivateUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'RemoveUser', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.RemoveUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'ChangePassword', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.ChangePasswordEvent.trigger(res);
		});
		webApiService.on('UsersService', 'ChangePasswordForUser', 'Main', (res: WsResponseModelT<BaseResponse>) => {
			self.ChangePasswordForUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'UsersInRoles', 'Main', (res: WsResponseModelT<Array<number>>) => {
			self.UsersInRolesEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetList', 'Main', (res: WsResponseModelT<SearchUserResponse>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetShortUser', 'Main', (res: WsResponseModelT<SearchUserResponse>) => {
			self.GetShortUserEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetAdminUsers', 'Main', (res: WsResponseModelT<Array<GetAdminUsersResponse>>) => {
			self.GetAdminUsersEvent.trigger(res);
		});
		webApiService.on('UsersService', 'GetRolesList', 'Main', (res: WsResponseModelT<ListResponseT<RoleResponse>>) => {
			self.GetRolesListEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	async GetRoles() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetRoles',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновить инфо пользователя
	 */
	async UpdateUser(request: UpdateUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'UpdateUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление пользователей
	 */
	async DeleteUser(request: RemoveUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'DeleteUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Вход
	 */
	async Login(request: LoginRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'Login',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async RegisterUser(request: RegisterUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'RegisterUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Начало восстановлени пароля
	 */
	async ResetPasswordGetToken(request: ResetPasswordGetTokenRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'ResetPasswordGetToken',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Конец восстановления пароля
	 */
	async ResetPassword(request: ResetPasswordRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'ResetPassword',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение короткой информации о пользователе по токену активации
	 */
	async GetUserShortInfoByTokenActivation(request: GetUserShortInfoByTokenActivationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetUserShortInfoByTokenActivation',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Вход
	 */
	async Logout() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'Logout',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить текушего пользователя
	 */
	async GetCurrentUser() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetCurrentUser',
		})

		webApiService.send(sendRequest);
	}

	async GetUser(request: GetUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async Register(request: RegisterUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'Register',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async Activate(request: ActivateUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'Activate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Быстрая активация пользователя
	 */
	async FastActivateUser(request: FastActivateUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'FastActivateUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление пользователя
	 */
	async RemoveUser(request: RemoveUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'RemoveUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Запрос на смену пароля
	 */
	async ChangePassword(request: ChangePasswordUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'ChangePassword',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение пароля для пользователя
	 */
	async ChangePasswordForUser(request: ChangePasswordForUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'ChangePasswordForUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список пользователей у которых есть заданная роль
	 */
	async UsersInRoles(roles: Array<TypeRoles>) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'UsersInRoles',
			Value: typeof(roles) === 'object' ? JSON.stringify(roles) : roles,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список пользователей
	 */
	async GetList(request: GetUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async GetShortUser(request: GetUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetShortUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение поьзователей с ролью админ
	 */
	async GetAdminUsers() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetAdminUsers',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список ролей
	 */
	async GetRolesList() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetRolesList',
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	async getRolesAsync(): Promise<BaseResponseT<ListResponseT<RoleResponse>>> {
		return new Promise<BaseResponseT<ListResponseT<RoleResponse>>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetRoles',
				Callback: (response: WsResponseModelT<BaseResponseT<ListResponseT<RoleResponse>>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponseT<ListResponseT<RoleResponse>>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновить инфо пользователя
	 */
	async updateUserAsync(request: UpdateUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'UpdateUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление пользователей
	 */
	async deleteUserAsync(request: RemoveUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'DeleteUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Вход
	 */
	async loginAsync(request: LoginRequest): Promise<UserResponse> {
		return new Promise<UserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'Login',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async registerUserAsync(request: RegisterUserRequest): Promise<BaseResponseT<RegisterUserResponse>> {
		return new Promise<BaseResponseT<RegisterUserResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'RegisterUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponseT<RegisterUserResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponseT<RegisterUserResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Начало восстановлени пароля
	 */
	async resetPasswordGetTokenAsync(request: ResetPasswordGetTokenRequest): Promise<BaseResponseT<ResetPasswordGetTokenResponse>> {
		return new Promise<BaseResponseT<ResetPasswordGetTokenResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'ResetPasswordGetToken',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponseT<ResetPasswordGetTokenResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponseT<ResetPasswordGetTokenResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Конец восстановления пароля
	 */
	async resetPasswordAsync(request: ResetPasswordRequest): Promise<BaseResponseT<UserResponse>> {
		return new Promise<BaseResponseT<UserResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'ResetPassword',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponseT<UserResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponseT<UserResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение короткой информации о пользователе по токену активации
	 */
	async getUserShortInfoByTokenActivationAsync(request: GetUserShortInfoByTokenActivationRequest): Promise<GetUserShortInfoByTokenActivationResponse> {
		return new Promise<GetUserShortInfoByTokenActivationResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetUserShortInfoByTokenActivation',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetUserShortInfoByTokenActivationResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetUserShortInfoByTokenActivationResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Вход
	 */
	async logoutAsync(): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'Logout',
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить текушего пользователя
	 */
	async getCurrentUserAsync(): Promise<UserResponse> {
		return new Promise<UserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetCurrentUser',
				Callback: (response: WsResponseModelT<UserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getUserAsync(request: GetUserRequest): Promise<UserModel> {
		return new Promise<UserModel>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UserModel>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserModel)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async registerAsync(request: RegisterUserRequest): Promise<RegisterUserResponse> {
		return new Promise<RegisterUserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'Register',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<RegisterUserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as RegisterUserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async activateAsync(request: ActivateUserRequest): Promise<UserResponse> {
		return new Promise<UserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'Activate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Быстрая активация пользователя
	 */
	async fastActivateUserAsync(request: FastActivateUserRequest): Promise<UserResponse> {
		return new Promise<UserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'FastActivateUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление пользователя
	 */
	async removeUserAsync(request: RemoveUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'RemoveUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Запрос на смену пароля
	 */
	async changePasswordAsync(request: ChangePasswordUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'ChangePassword',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение пароля для пользователя
	 */
	async changePasswordForUserAsync(request: ChangePasswordForUserRequest): Promise<BaseResponse> {
		return new Promise<BaseResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'ChangePasswordForUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<BaseResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as BaseResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список пользователей у которых есть заданная роль
	 */
	async usersInRolesAsync(roles: Array<TypeRoles>): Promise<Array<number>> {
		return new Promise<Array<number>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'UsersInRoles',
				Value: typeof(roles) === 'object' ? JSON.stringify(roles) : roles,
				Callback: (response: WsResponseModelT<Array<number>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<number>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список пользователей
	 */
	async getListAsync(request: GetUsersRequest): Promise<SearchUserResponse> {
		return new Promise<SearchUserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<SearchUserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SearchUserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getShortUserAsync(request: GetUsersRequest): Promise<SearchUserResponse> {
		return new Promise<SearchUserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetShortUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<SearchUserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as SearchUserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение поьзователей с ролью админ
	 */
	async getAdminUsersAsync(): Promise<Array<GetAdminUsersResponse>> {
		return new Promise<Array<GetAdminUsersResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetAdminUsers',
				Callback: (response: WsResponseModelT<Array<GetAdminUsersResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<GetAdminUsersResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список ролей
	 */
	async getRolesListAsync(): Promise<ListResponseT<RoleResponse>> {
		return new Promise<ListResponseT<RoleResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetRolesList',
				Callback: (response: WsResponseModelT<ListResponseT<RoleResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ListResponseT<RoleResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}